class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._closeTimeout = null;

    this.addEventListener('mouseenter', this._onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this._onMouseLeave.bind(this));
  }

  _onMouseEnter() {
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
      this._closeTimeout = null;
    }

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      document.querySelectorAll('header-menu details[open]').forEach((d) => {
        if (d !== this.mainDetailsToggle) {
          d.removeAttribute('open');
          d.querySelector('summary').setAttribute('aria-expanded', false);
        }
      });

      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      this.onToggle();
      this._animateMegaItems();
    }
  }

  _onMouseLeave() {
    this._closeTimeout = setTimeout(() => {
      this.close();
      this._closeTimeout = null;
    }, 300);
  }

  _animateMegaItems() {
    // Cible les <li> colonnes du mega menu (premier niveau)
    const items = this.mainDetailsToggle.querySelectorAll('.mega-menu__list > li');

    items.forEach((item, i) => {
      // Reset pour que l'anim rejoue à chaque ouverture
      item.style.animation = 'none';
      item.offsetHeight; // force reflow
      item.style.animation = '';
      item.style.setProperty('--mega-item-index', i);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
